import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import { useShadowDOM } from '../hooks/useShadowDOM/index.js';
export const ShadowRoot = ({ children }) => {
    const { app } = useShadowDOM();
    const [shadowRoot, setShadowRoot] = useState();
    useEffect(() => {
        if (app && !app?.shadowRoot) {
            setShadowRoot(app.attachShadow({
                mode: 'open'
            }));
        }
    }, []);
    if (shadowRoot) {
        return createPortal(children, shadowRoot);
    }
    return null;
};
//# sourceMappingURL=index.js.map